<template>
  <el-dropdown class="sys-lang-dropdown" @command="handleCommand" size="medium">
    <div class="sys-lang">
      <el-image class="lang-icon" :src="lang == 'zh-CN' ? LangZH : LangEN"></el-image>
      <span class="lang-text">{{$t('language.name')}}</span>
      <i class="arror el-icon-caret-bottom"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="(item, index) of list" :key="index" :disabled="$t('language.name') == item.name" :command="item.key">
        <el-image class="lang-icon" :src="item.langIcon"></el-image>
        <span class="lang-text">{{item.name}}</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import LangZH from '@/assets/img/login/lang-zh.png'
  import LangEN from '@/assets/img/login/lang-en.png'
  import { switchLanguage } from "@/api/home/home";
  import {getSysApi, getUserCusList} from "@/api/sys/cus";
  import { setRem } from "@/util/commen";
  export default {
    name: 'change-language',
    data() {
      return {
        LangZH,
        LangEN,
        lang: localStorage.getItem('Accept-Language') || 'zh-CN',
        list: [
            { key: 'en-US', name: 'English', langIcon: LangEN },
            { key: 'zh-CN', name: '中文', langIcon: LangZH },
          ]
        }
    },
    created() {
      setRem()
    },
    methods: {
      handleCommand(value) {
        if(this.$route.path == '/login') {
          localStorage.setItem('Accept-Language', value)
          location.reload()
          this.$emit('reload');
          return
        }
        const params = {
          request_locale: ''
        };

        if(value == "en-US"){
          params.language = "en_US";
        }else{
          params.language = "zh_CN";
        }

        switchLanguage(params).then(response => {
          const data = response.data.data;
          const userInfo = {
            ...data
          };
          this.$store.commit('SET_ACCESS_TOKEN', response.data.data.accessToken);
          this.$store.commit('SET_USER_INFO', userInfo);
          this.$i18n.locale = value
          localStorage.setItem('Accept-Language', value)
          location.reload()
          this.$emit('reload');
        }).catch(error => {
          console.error(error);
        });
      }
    }
  }
</script>
<style scoped lang="scss">
</style>
